import { FC } from "react";

import BasicWidget, {
  BasicWidgetProps,
} from "src/dynamic-view-renderer/Widgets/BasicWidget/BasicWidget.tsx";
import { useGetBlacklistSchemasQuery } from "src/graphql/anti-fraud/queries/blacklists/BlacklistSchemasQuery.ts";
import { useT } from "src/internationalization";

import WidgetContainer from "../WidgetContainer";

const WidgetBlacklistSchema: FC<Omit<BasicWidgetProps, "itemSchema">> = ({
  widgetConfig,
  rowConfiguration,
  ...props
}) => {
  const { data: blacklistSchemaData, error: blacklistSchemaError } = useGetBlacklistSchemasQuery();
  const t = useT();

  const blacklistSchema = blacklistSchemaData
    ? { itemTypes: blacklistSchemaData, elementTypes: [] }
    : undefined;

  if (blacklistSchemaError) {
    return (
      <WidgetContainer widgetConfig={widgetConfig} rowConfiguration={rowConfiguration}>
        <div className="text-supportError mb-4">{t("general.clientSchemaError")}</div>
      </WidgetContainer>
    );
  }

  return (
    <BasicWidget
      {...props}
      itemSchema={blacklistSchema}
      rowConfiguration={rowConfiguration}
      widgetConfig={widgetConfig}
    />
  );
};

export default WidgetBlacklistSchema;
